import api from './index';
import sharedApi from './shared';

const companiesAPI = {
  // Search companies by name using shared API
  searchCompanies: (searchTerm) => {
    return sharedApi.get('/history_companies', {
      params: { search_term: searchTerm }
    });
  },

  // Create a new company using applicant API
  createCompany: (name) => {
    return api.post('/applicants/history_companies', { name });
  }
};

export default companiesAPI;
